function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcnFlowsensor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 132",
    d: "M36.09 26.56a4.7 4.7 0 0 1-3.61-1.8 3.45 3.45 0 0 0-5.66 0 4.51 4.51 0 0 1-7.21 0 3.63 3.63 0 0 0-2.83-1.48A3.63 3.63 0 0 0 14 24.76a4.69 4.69 0 0 1-3.6 1.8 4.7 4.7 0 0 1-3.61-1.8 3.63 3.63 0 0 0-2.83-1.48.55.55 0 1 1 0-1.1A4.67 4.67 0 0 1 7.52 24a3.65 3.65 0 0 0 2.83 1.48A3.61 3.61 0 0 0 13.17 24a4.51 4.51 0 0 1 7.22 0 3.59 3.59 0 0 0 2.82 1.48A3.65 3.65 0 0 0 26 24a4.51 4.51 0 0 1 7.22 0 3.65 3.65 0 0 0 2.83 1.48.55.55 0 0 1 0 1.09m0 4.47a.55.55 0 0 0 0-1.09 3.65 3.65 0 0 1-2.83-1.48 4.51 4.51 0 0 0-7.22 0 3.44 3.44 0 0 1-5.65 0 4.51 4.51 0 0 0-7.22 0 3.63 3.63 0 0 1-2.82 1.48 3.65 3.65 0 0 1-2.83-1.48 4.67 4.67 0 0 0-3.61-1.81.55.55 0 1 0 0 1.1 3.65 3.65 0 0 1 2.83 1.47 4.64 4.64 0 0 0 7.3-.01 3.65 3.65 0 0 1 2.83-1.47 3.65 3.65 0 0 1 2.83 1.47 4.5 4.5 0 0 0 7.21 0 3.46 3.46 0 0 1 5.66 0A4.67 4.67 0 0 0 36.09 31m0 4.47a.55.55 0 0 0 0-1.09 3.65 3.65 0 0 1-2.83-1.48 4.51 4.51 0 0 0-7.22 0 3.44 3.44 0 0 1-5.65 0 4.51 4.51 0 0 0-7.22 0 3.63 3.63 0 0 1-2.82 1.48 3.65 3.65 0 0 1-2.83-1.48 4.67 4.67 0 0 0-3.61-1.81.55.55 0 0 0 0 1.1 3.65 3.65 0 0 1 2.83 1.47 4.568 4.568 0 0 0 7.26.03 3.65 3.65 0 0 1 2.83-1.47 3.65 3.65 0 0 1 2.83 1.47 4.5 4.5 0 0 0 7.21 0 3.46 3.46 0 0 1 5.66 0 4.67 4.67 0 0 0 3.61 1.81m-7.9-23.24a.55.55 0 0 0 0-1.09H10.91a.55.55 0 1 0 0 1.09h17.28m-5.74 6.62a.51.51 0 0 0 .38-.16l7-7-7-7a.544.544 0 1 0-.77.77l6.26 6.26L22.06 18a.55.55 0 0 0 .39.93",
    style: {
      fill: "#5e5e5d"
    }
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnFlowsensor);
export default __webpack_public_path__ + "static/media/icn-flowsensor.1d773755640d487c2809becb07c8a7d5.svg";
export { ForwardRef as ReactComponent };